import { render, staticRenderFns } from "./DetailCorrectScoreLock.vue?vue&type=template&id=25d089a5&scoped=true"
import script from "./DetailCorrectScoreLock.vue?vue&type=script&lang=js"
export * from "./DetailCorrectScoreLock.vue?vue&type=script&lang=js"
import style0 from "./DetailCorrectScoreLock.vue?vue&type=style&index=0&id=25d089a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d089a5",
  null
  
)

export default component.exports